import { EventEmitter, DebugEventEmitter, DebugEmitter } from './events';

if (process.env.BROWSER != 'true') {
	require('./process');
}

export { EventEmitter, DebugEventEmitter, DebugEmitter };

